import { Injectable } from '@angular/core';
import { DbDaoService, GetAllDataOptions } from '../db/db-dao.service';
import { UPDATES_TYPES } from '../../constants/updates-types.const';
import { Observable } from 'rxjs';
import { Store } from '../../classes/store.class';
import { DbEntityProvider } from './db-entity.provider';
import { Query } from '@paymash/capacitor-database-plugin';

@Injectable()
export class StoresProvider extends DbEntityProvider {
  constructor(dbDaoService: DbDaoService) {
    super(UPDATES_TYPES.Store.type, dbDaoService);
  }

  getByUuid(uuid: string): Observable<Store> {
    return <Observable<Store>>this.getEntityByUuid(uuid);
  }

  getList(): Observable<Store[]> {
    return <Observable<Store[]>>this.getEntitiesList();
  }

  getListByParams(queryParams: Query, options?: GetAllDataOptions): Observable<Store[]> {
    return <Observable<Store[]>>this.getEntitiesListByParams(queryParams, options).pipe(this.mapPipeTransformEntities());
  }
}
